export interface Snackbar {
    active: boolean;
    message: string;
    link: string;
    buttonText: string;
    callback?: Function;
}

export interface UiState {
    snackbar: Snackbar;
}

export const defaultState: UiState = {
  snackbar: {
    active: false,
    message: '',
    link: '',
    buttonText: '',
    callback: undefined
  }
}

export default {
  ...defaultState
}
